/* tslint:disable */
/* eslint-disable */
/**
 * pinnacle-backend API spec
 * Backend Service for Pinnacle Underwriting | [swagger.json](pinnacle/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PremiumScheduleAllocationDto } from './PremiumScheduleAllocationDto';
import {
    PremiumScheduleAllocationDtoFromJSON,
    PremiumScheduleAllocationDtoFromJSONTyped,
    PremiumScheduleAllocationDtoToJSON,
    PremiumScheduleAllocationDtoToJSONTyped,
} from './PremiumScheduleAllocationDto';
import type { SyncReceiptSettlementExchangeRatePayloadDto } from './SyncReceiptSettlementExchangeRatePayloadDto';
import {
    SyncReceiptSettlementExchangeRatePayloadDtoFromJSON,
    SyncReceiptSettlementExchangeRatePayloadDtoFromJSONTyped,
    SyncReceiptSettlementExchangeRatePayloadDtoToJSON,
    SyncReceiptSettlementExchangeRatePayloadDtoToJSONTyped,
} from './SyncReceiptSettlementExchangeRatePayloadDto';

/**
 * 
 * @export
 * @interface UpdateReceiptPayloadDto
 */
export interface UpdateReceiptPayloadDto {
    /**
     * Transaction date
     * @type {Date}
     * @memberof UpdateReceiptPayloadDto
     */
    transactionDate?: Date;
    /**
     * Type of receipt
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    receiptType?: UpdateReceiptPayloadDtoReceiptTypeEnum;
    /**
     * Bank account number
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    bankAccountNumber?: string;
    /**
     * Receipt amount
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    amount?: string;
    /**
     * Bank fee
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    bankFee?: string;
    /**
     * Source broker ID
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    sourceBrokerId?: string;
    /**
     * Free-text input for broker reference
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    sourceBrokerReference?: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof UpdateReceiptPayloadDto
     */
    fileIds?: Array<string>;
    /**
     * 
     * @type {string}
     * @memberof UpdateReceiptPayloadDto
     */
    comment?: string;
    /**
     * Premium schedule allocations
     * @type {Array<PremiumScheduleAllocationDto>}
     * @memberof UpdateReceiptPayloadDto
     */
    premiumScheduleAllocations?: Array<PremiumScheduleAllocationDto>;
    /**
     * Receipt settlement exchange rates
     * @type {Array<SyncReceiptSettlementExchangeRatePayloadDto>}
     * @memberof UpdateReceiptPayloadDto
     */
    receiptSettlementExchangeRates?: Array<SyncReceiptSettlementExchangeRatePayloadDto>;
}


/**
 * @export
 */
export const UpdateReceiptPayloadDtoReceiptTypeEnum = {
    Premium: 'Premium',
    Claims: 'Claims',
    Other: 'Other'
} as const;
export type UpdateReceiptPayloadDtoReceiptTypeEnum = typeof UpdateReceiptPayloadDtoReceiptTypeEnum[keyof typeof UpdateReceiptPayloadDtoReceiptTypeEnum];


/**
 * Check if a given object implements the UpdateReceiptPayloadDto interface.
 */
export function instanceOfUpdateReceiptPayloadDto(value: object): value is UpdateReceiptPayloadDto {
    return true;
}

export function UpdateReceiptPayloadDtoFromJSON(json: any): UpdateReceiptPayloadDto {
    return UpdateReceiptPayloadDtoFromJSONTyped(json, false);
}

export function UpdateReceiptPayloadDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReceiptPayloadDto {
    if (json == null) {
        return json;
    }
    return {
        
        'transactionDate': json['transactionDate'] == null ? undefined : (new Date(json['transactionDate'])),
        'receiptType': json['receiptType'] == null ? undefined : json['receiptType'],
        'bankAccountNumber': json['bankAccountNumber'] == null ? undefined : json['bankAccountNumber'],
        'amount': json['amount'] == null ? undefined : json['amount'],
        'bankFee': json['bankFee'] == null ? undefined : json['bankFee'],
        'sourceBrokerId': json['sourceBrokerId'] == null ? undefined : json['sourceBrokerId'],
        'sourceBrokerReference': json['sourceBrokerReference'] == null ? undefined : json['sourceBrokerReference'],
        'fileIds': json['fileIds'] == null ? undefined : json['fileIds'],
        'comment': json['comment'] == null ? undefined : json['comment'],
        'premiumScheduleAllocations': json['premiumScheduleAllocations'] == null ? undefined : ((json['premiumScheduleAllocations'] as Array<any>).map(PremiumScheduleAllocationDtoFromJSON)),
        'receiptSettlementExchangeRates': json['receiptSettlementExchangeRates'] == null ? undefined : ((json['receiptSettlementExchangeRates'] as Array<any>).map(SyncReceiptSettlementExchangeRatePayloadDtoFromJSON)),
    };
}

export function UpdateReceiptPayloadDtoToJSON(json: any): UpdateReceiptPayloadDto {
    return UpdateReceiptPayloadDtoToJSONTyped(json, false);
}

export function UpdateReceiptPayloadDtoToJSONTyped(value?: UpdateReceiptPayloadDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'transactionDate': value['transactionDate'] == null ? undefined : ((value['transactionDate']).toISOString()),
        'receiptType': value['receiptType'],
        'bankAccountNumber': value['bankAccountNumber'],
        'amount': value['amount'],
        'bankFee': value['bankFee'],
        'sourceBrokerId': value['sourceBrokerId'],
        'sourceBrokerReference': value['sourceBrokerReference'],
        'fileIds': value['fileIds'],
        'comment': value['comment'],
        'premiumScheduleAllocations': value['premiumScheduleAllocations'] == null ? undefined : ((value['premiumScheduleAllocations'] as Array<any>).map(PremiumScheduleAllocationDtoToJSON)),
        'receiptSettlementExchangeRates': value['receiptSettlementExchangeRates'] == null ? undefined : ((value['receiptSettlementExchangeRates'] as Array<any>).map(SyncReceiptSettlementExchangeRatePayloadDtoToJSON)),
    };
}

